import type { ViewerPluginCreator } from './../ricos-types';

import { DEFAULTS } from './consts';
import type { ImagePluginViewerConfig } from './types';
import { IMAGE_TYPE } from './types'; // TODO: remove from here as it's being exported from ricos-content
import { nodeViewRenderers } from './viewer/node-view-renderers';

export const pluginImage: ViewerPluginCreator<ImagePluginViewerConfig> = config => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: IMAGE_TYPE,
    nodeViewRenderers,
  };
};
